import {FacePart} from "../../common";

export default new FacePart({
	render () {
		return `
			<g transform="translate(0.000000, 8.000000)">
				<circle fill="#FFFFFF" cx="30" cy="22" r="14"/>
				<circle fill="#FFFFFF" cx="82" cy="22" r="14"/>
				<circle fill-opacity="0.699999988" fill="#000000" cx="30" cy="22" r="6"/>
				<circle fill-opacity="0.699999988" fill="#000000" cx="82" cy="22" r="6"/>
			</g>
		`;
	},
});



// WEBPACK FOOTER //
// ./src/face/eyes/surprised.js